import logo from "modules/development/assets/images/rubk-logo.svg";
import * as React from "react";
import i18n from "i18n";
import { NavLink } from "react-router-dom";
import {
  AppBar,
  Tab,
  Toolbar,
  withStyles,
  Grid,
  Button,
} from "@material-ui/core";
import ProfileOverlay from "./ProfileOverlay";
import { LoginStore } from "modules/login/LoginStore";
import { ProfileStore } from "modules/profile/ProfileStore";
import { WBSStore } from "modules/WBS/WBSStore";

const styles = (theme) => ({
  flex: {
    flex: 1,
    justifyContent: "space-between",
    padding: "0 28px",
  },
  link: {
    textDecoration: "none",
  },
  tabsRoot: {
    boxShadow: "unset",
    fontSize: "14px",
  },
  tabRoot: {
    textTransform: "unset" as any,
    fontFamily: "Roboto",
  },
  tabLabel: {
    color: "#afafaf",
    fontWeight: 300,
    padding: "20px",
    "&:hover": {
      color: "#ffffff",
    },
    transition: "all 0.3s ease-in",
  },
  activeLink: {
    "& > button > span > span > span": {
      color: "#ffffff",
      fontWeight: 600,
    },
  },
  btnSubscribeNow: {
    backgroundColor: "#9AAF00",
    padding: "10px 16px",
    "&:hover": {
      backgroundColor: "#92A501",
    },
  },
});

type IProps = {
  classes: any;
};

class TopBar extends React.Component<IProps> {
  render() {
    const { classes } = this.props,
      tabClasses = { root: classes.tabRoot, label: classes.tabLabel };
    return (
      <AppBar position={"sticky"}>
        <Toolbar className={classes.flex}>
          <img style={{ height: "21px" }} src={logo} />
          <Grid className={classes.tabsRoot}>
            <NavLink
              to={LoginStore.expiredTrial() ? "#" : "/menu/development"}
              className={classes.link}
              activeClassName={classes.activeLink}
            >
              <Tab classes={tabClasses} label={i18n.menu.development} />
            </NavLink>
            <NavLink
              to={LoginStore.expiredTrial() ? "#" : "/menu/rateLibraries"}
              className={classes.link}
              activeClassName={classes.activeLink}
            >
              <Tab classes={tabClasses} label={i18n.menu.rateLibrary} />
            </NavLink>
            <NavLink
              to="#"
              className={classes.link}
              activeClassName={classes.activeLink}
            >
              <Tab
                classes={tabClasses}
                label={i18n.menu.learning}
                onClick={() => {
                  window.open(
                    "https://megasistemas.atlassian.net/wiki/spaces/helprubk/overview"
                  );
                }}
              />
            </NavLink>
          </Grid>
          <Grid>
            {LoginStore.isTrialUser() ? (
              <Button
                className={classes.btnSubscribeNow}
                onClick={() => WBSStore.subscribeShowChange(true)}
              >
                {i18n.trialRegister.subscribeNow02}
              </Button>
            ) : (
              <></>
            )}
            <ProfileOverlay />
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styles)(TopBar);



// WEBPACK FOOTER //
// ./src/modules/menu/components/layouts/TopBar.tsx